const STORAGE_PREFIX = 'UI_LIB_';
export const getStorageKey = (key) => `${STORAGE_PREFIX}${key}`;
export const THEMES = {
    dark: 'themedark',
    light: 'themelight'
};
export const DATE_FORMAT = 'MM/dd/yyyy';
export const DATE_FORMAT_MOMENT = 'MM/DD/YYYY';
